export default [
    {
        path: '/partners/:id',
        name: 'partner',
        component: { render: () => null },
        meta: { isModalVisible: true, noScroll: true },
    },
];
